import AOS from "aos";

function initSliders() {
    relatedProductsCarousel();
    logosSlider();
    productsGridCarousel();
    sliderLinks();
}


function productsGridCarousel() {
    let productsGrid = document.querySelector('.products-grid-slider__carousel');
    if (productsGrid) {
        let productGridCategoriesParent = document.querySelector('.products-grid__cat-slider');
        let productsGridCategories = productGridCategoriesParent.querySelectorAll('.products-grid-slider__category');
        productsGridCategories.forEach((category, index) => {
            category.addEventListener('click', () => {
                $('.products-grid-slider__categories').slick('slickGoTo', index);
                AOS.refresh();
            });
        });
        $('.products-grid__cat-slider').slick({
            slidesToShow:3,
            slidesToScroll: 1,
            arrows: false,
            variableWidth: true,
            infinite: false,
            asNavFor: '.products-grid-slider__carousel',
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        arrows: false,
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        variableWidth: true
                    }
                }
            ]
        });
        $('.products-grid-slider__carousel.active').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: false,
            arrows: true,
            infinite: true,
            adaptiveHeight: true,
            speed: 500,
            fade: true,
            cssEase: 'linear',
            asNavFor: '.products-grid__cat-slider',
            nextArrow: '<div class="products-next-arrow"><svg width="21" height="32" viewBox="0 0 21 32" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
                '<path d="M13.1 16L0.833313 3.73333L4.56665 0L20.5666 16L4.56665 32L0.833313 28.2667L13.1 16Z" fill="#2A2A2A"/>\n' +
                '</svg></div>',
            prevArrow: '<div class="products-prev-arrow"><svg width="21" height="32" viewBox="0 0 21 32" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
                '<path d="M7.90002 16L20.1667 28.2667L16.4334 32L0.433355 16L16.4334 1.58097e-06L20.1667 3.73334L7.90002 16Z" fill="#2A2A2A"/>\n' +
                '</svg></div>',
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        arrows: false,
                    }
                }
            ]
        });

    }
}

function sliderLinks() {
    let sliderLinks = document.querySelector('.slider-links__slider');
    if (sliderLinks && window.innerWidth < 768) {
        let centerMode = false;
        let activeItem = document.querySelectorAll('.products-grid-slider__category');
        let activeItemIndex = 0;
        activeItem.forEach((item, index) => {
            if (item.classList.contains('active')) {
                activeItemIndex = index;
            }
        });
        if (activeItemIndex > 0) {
            centerMode = true;
        }
        $('.slider-links__slider').slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            arrows: false,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        arrows: false,
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        variableWidth: true,
                        centerMode: centerMode,
                    }
                }
            ]
        });
        $('.slider-links__slider').slick('slickGoTo', activeItemIndex);
    }
}

function relatedProductsCarousel() {
    $('.related.products ul.products').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        dots: false,
        arrows: true,
        nextArrow: '<div class="slider__arrow"><span>›</span></div>',
        prevArrow: '<div class="slider__arrow left"><span>‹</span></div>',
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                }
            }
        ]
    });
}

function logosSlider() {
    let logosSlider = document.querySelector('.logos-slider__slider');
    if (logosSlider) {
        $('.logos-slider__slider').slick({
            slidesToShow: 5,
            slidesToScroll: 1,
            dots: false,
            arrows: false,
            autoplay: true,
            autoplaySpeed: 0,
            speed: 10000,
            cssEase: 'linear',
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 1,
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        centerMode: true,
                    }
                }
            ]
        });
    }
}

export default {
    initSliders,
};
